// import * as React from "react";
// import PropTypes from "prop-types";

// import CssBaseline from "@mui/material/CssBaseline";
// import Box from "@mui/material/Box";
// import Divider from "@mui/material/Divider";
// import { ThemeProvider, createTheme } from "@mui/material/styles";
// import ToggleButton from "@mui/material/ToggleButton";
// import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
// import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
// import HeaderBar from "./components/HeaderBar";
// import Hero from "./components/Hero";
// import LogoCollection from "./components/LogoCollection";
// import Highlights from "./components/Highlights";
// import Pricing from "./components/Pricing";
// import Services from "./components/Services";
// import Testimonials from "./components/Testimonials";
// import FAQ from "./components/FAQ";
// import Footer from "./components/Footer";
// import getLPTheme from "./getLPTheme";

// const ToggleCustomTheme = ({ showCustomTheme, toggleCustomTheme }) => {
//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         width: "100dvw",
//         position: "fixed",
//         bottom: 24,
//       }}
//     >
//       <ToggleButtonGroup
//         color="primary"
//         exclusive
//         value={showCustomTheme}
//         onChange={toggleCustomTheme}
//         aria-label="Platform"
//         sx={{
//           backgroundColor: "background.default",
//           "& .Mui-selected": {
//             pointerEvents: "none",
//           },
//         }}
//       >
//         <ToggleButton value>
//           <AutoAwesomeRoundedIcon sx={{ fontSize: "20px", mr: 1 }} />
//           Custom theme
//         </ToggleButton>
//         <ToggleButton value={false}>Material Design 2</ToggleButton>
//       </ToggleButtonGroup>
//     </Box>
//   );
// };

// ToggleCustomTheme.propTypes = {
//   showCustomTheme: PropTypes.shape({
//     valueOf: PropTypes.func.isRequired,
//   }).isRequired,
//   toggleCustomTheme: PropTypes.func.isRequired,
// };

// const App = () => {
//   const [mode, setMode] = React.useState("light");
//   const [showCustomTheme, setShowCustomTheme] = React.useState(true);
//   const LPtheme = createTheme(getLPTheme(mode));
//   const defaultTheme = createTheme({ palette: { mode } });

//   const toggleColorMode = () => {
//     setMode((prev) => (prev === "dark" ? "light" : "dark"));
//   };

//   const toggleCustomTheme = () => {
//     setShowCustomTheme((prev) => !prev);
//   };

//   return (
//     <ThemeProvider theme={showCustomTheme ? LPtheme : defaultTheme}>
//       <CssBaseline />
//       <HeaderBar mode={mode} toggleColorMode={toggleColorMode} />
//       <Hero />
//       <Box sx={{ bgcolor: "background.default" }}>
//         <Services />
//         <LogoCollection />
//         <Divider />
//         <Testimonials />
//         <Divider />
//         <Highlights />
//         <Divider />
//         <Pricing />
//         <Divider />
//         <FAQ />
//         <Divider />
//         <Footer />
//       </Box>
//       {/* <ToggleCustomTheme
//         showCustomTheme={showCustomTheme}
//         toggleCustomTheme={toggleCustomTheme}
//       /> */}
//     </ThemeProvider>
//   );
// };

// export default App;

import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Homepage from "./pages/Homepage";
import GetQuote from "./pages/GetQuote";
import { CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import getLPTheme from "./getLPTheme";
import OurServicesPage from "./pages/OurServicesPage";
import PricingPage from "./pages/PricingPage";
import Projects from "./pages/Projects";
import Company from "./pages/Company";
import Testimonials from "./pages/Testimonials";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "aos/dist/aos.css";
import Calendy from "./pages/Calendy";

const App = () => {
  const [mode, setMode] = useState(() => {
    return localStorage.getItem("mode") || "light";
  });
  const LPtheme = createTheme(getLPTheme(mode));

  const toggleColorMode = () => {
    setMode((prevMode) => {
      const newMode = prevMode === "dark" ? "light" : "dark";
      localStorage.setItem("mode", newMode);
      return newMode;
    });
  };

  return (
    <>
      <ThemeProvider theme={LPtheme}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <Homepage mode={mode} toggleColorMode={toggleColorMode} />
              }
            />
            <Route
              path="/get-a-quote"
              element={
                <GetQuote mode={mode} toggleColorMode={toggleColorMode} />
              }
            />
            <Route
              path="/pricing"
              element={
                <PricingPage mode={mode} toggleColorMode={toggleColorMode} />
              }
            />
            <Route
              path="/services"
              element={
                <OurServicesPage
                  mode={mode}
                  toggleColorMode={toggleColorMode}
                />
              }
            />

            <Route
              path="/projects"
              element={
                <Projects mode={mode} toggleColorMode={toggleColorMode} />
              }
            />
            <Route
              path="/company"
              element={
                <Company mode={mode} toggleColorMode={toggleColorMode} />
              }
            />
            <Route
              path="/testimonials"
              element={
                <Testimonials mode={mode} toggleColorMode={toggleColorMode} />
              }
            />
            <Route
              path="/book-a-call"
              element={
                <Calendy mode={mode} toggleColorMode={toggleColorMode} />
              }
            />
          </Routes>
        </BrowserRouter>
        <ToastContainer />
      </ThemeProvider>
    </>
  );
};

export default App;
